export const environment = {
  production: false,
  // Used on this PC. On Tailscale the UI calls the same host on this port.
  apiBaseUrl: 'http://127.0.0.1:8080',
  publicBaseUrl: 'https://commpare.app'
};
